import { ELoadingOptions } from "@modules/loader/useLoader.hook";
import type IChampion from "@modules/skins/shared/models/IChampion.model";
import type ISkin from "@modules/skins/shared/models/ISkin.model";
import type IProduct from "../models/IProduct";
import LOL_API from "./lolFetcher";

const BASE_URL = "/skins";

class SkinAPI {
  static getSkinsGroupedByChampions = () =>
    LOL_API.get<IChampion[]>(BASE_URL, undefined, ELoadingOptions.NONE);

  static getPopular = () => LOL_API.get<ISkin[]>(`${BASE_URL}/popular`);

  static get = (slug: string) => LOL_API.get<ISkin>(`${BASE_URL}/slug/${slug}`);

  static getProduct = (slug: string) =>
    LOL_API.get<IProduct[]>(`${BASE_URL}/slug/${slug}/products`);
}

export default SkinAPI;
